import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { StripeService } from './stripe.service';
import { StripeConnector } from './stripe-connector.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class StripeServiceModule {
  static forRoot(): ModuleWithProviders<StripeServiceModule> {
    return {
      ngModule: StripeServiceModule,
      providers: [StripeService, StripeConnector],
    };
  }
}
